const STORAGE_KEY = "lanis_custom_service_types";

function getCustomServiceTypes() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function addCustomServiceType(name, builtInServiceTypes = []) {
  if (!name || !name.trim()) return;
  const trimmed = name.trim();
  const allExisting = [...builtInServiceTypes, ...getCustomServiceTypes()];
  if (allExisting.some(s => s.toLowerCase() === trimmed.toLowerCase())) return;
  const customExisting = getCustomServiceTypes();
  const updated = [...customExisting, trimmed].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // localStorage unavailable
  }
}

export function getAllServiceTypes(builtInServiceTypes) {
  const custom = getCustomServiceTypes();
  return [...builtInServiceTypes, ...custom].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
}
